export const BUILD_INFO = {
  sha: __APP_BUILD_SHA__,
  builtAt: __APP_BUILD_TIMESTAMP__,
};

export function getBuildLabel() {
  return `${BUILD_INFO.sha} @ ${BUILD_INFO.builtAt}`;
}
